var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-hidden leading-none flex items-center justify-center font-bold",class:[
    _vm.avatarColor
  ],attrs:{"aria-hidden":"true"}},[(_vm.image)?_c('img',{staticClass:"w-full h-full object-cover",attrs:{"src":_vm.image,"alt":_vm.username}}):_c('span',[_vm._v(_vm._s(_vm.userInitial))])])}
var staticRenderFns = []

export { render, staticRenderFns }